import { tryResolveContainerInfo } from '@ms/office-web-host';
import { IFluidCodeDetails } from '@fluidframework/core-interfaces';

export async function tryGetCodeDetails(url: string): Promise<IFluidCodeDetails> {
    let parsedUrl: URL = null;
    try {
        parsedUrl = new URL(url);
    } catch (e) {
        return undefined;
    }
    if (parsedUrl) {
        return tryResolveContainerInfo(parsedUrl);
    }
    return undefined;
}
